import React from 'react';
import img from '../images/Web-developer.svg';
import { Link } from 'react-router-dom';
import { commonStyles } from "../pages/commonStyles";
const Intro = () => {
  return (
    <div
     className="py-12"
      id="about"
    >
      <div
       className="flex flex-col-reverse lg:flex-row items-center justify-between gap-16 py-16"
        data-aos="fade-up"
      >
        {/* IMAGE SECTION */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={img}
            alt="Web Developer"
           className="w-full max-w-lg lg:max-w-2xl object-contain"
          />
        </div>

        {/* TEXT SECTION */}
        <div
         className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left lg:pl-10"
          data-aos="zoom-in"
          data-aos-delay="500"
        >
         <p className={`${commonStyles.paragraph} !text-blue-900 mb-4`}>
            We develop high quality bespoke web and mobile applications for
            organizations, institutions and SMEs
          </p>

           <p className={`${commonStyles.paragraph} mb-4`}>
            Our team is well versed in software development and is ready to help
            develop the applications of your choice.
          </p>

          <p className={`${commonStyles.paragraph} mb-4`}>
            We take responsibility for building custom software solutions that
            cater for automation of your business processes and improve
            efficiency.
          </p>
         <div className="mb-4 space-x-0 md:space-x-2 md:mb-8">
          <Link
            to="/contact"
          className="inline-flex items-center justify-center px-8 py-4 bg-blue-900 hover:bg-blue-500 text-white text-lg font-semibold rounded-xl shadow-lg transition-all duration-300 hover:scale-105">
          
            Contact Us
            <svg
              className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;